import { FLIPPER_KEYS } from '~/store/flippers/const'
import { FlipperResponseMap } from './types'

export const FLIPPER_RESPONSE_MAP: Partial<FlipperResponseMap> = {
  [FLIPPER_KEYS.XSGD_USE_FIAT_CURRENCY_NAME]: 'isUsingFiatCurrency',
} as const
